import { defineStore } from 'pinia';

export const useLocalStorageStore = defineStore('localStorage', {
  state: () => ({
    localStorageValue: localStorage.getItem('navTitle') || '首頁',
  }),
  actions: {
    updateLocalStorageValue(newValue) {
      this.localStorageValue = newValue;
      localStorage.setItem('navTitle', newValue);
    },
  },
});
